import type { AgentField } from '@shared/api';

import { useAgentTestFields } from './use-agent-test-fields';
import { useAgentTestMessages } from './use-agent-test-messages';

type UseAgentTestChatParams = {
  agentId: number;
  agentFields?: AgentField[] | null;
};

export const useAgentTestChat = ({ agentId, agentFields }: UseAgentTestChatParams) => {
  const { leadFields, clientFields, isLeadCreated, resetFieldValues } = useAgentTestFields({
    agentId,
    agentFields,
  });

  const messagesState = useAgentTestMessages({
    agentId,
    onAfterClear: resetFieldValues,
  });

  return {
    ...messagesState,
    leadFields,
    clientFields,
    isLeadCreated,
  };
};
